import {RetreatSession} from "./retreatsData";

export type SessionStatus = "past" | "ongoing" | "upcoming";

const WEEKDAYS = ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."];
const MONTHS = ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień",
    "październik", "listopad", "grudzień"];

function parse(isoDate: string): Date {
    const [y, m, d] = isoDate.split("-").map(Number);
    return new Date(y, m - 1, d);
}

function pad(n: number): string {
    return n < 10 ? `0${n}` : `${n}`;
}

export function todayIso(): string {
    const now = new Date();
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

export function sessionStatus(session: RetreatSession, today: string): SessionStatus {
    if (session.to < today) {
        return "past";
    }
    return session.from <= today ? "ongoing" : "upcoming";
}

/** "19–22.10.2026", "30.11–3.12.2026", "30.12.2026–2.01.2027" */
export function formatDateRange(session: RetreatSession): string {
    const from = parse(session.from);
    const to = parse(session.to);
    const toLabel = `${to.getDate()}.${pad(to.getMonth() + 1)}.${to.getFullYear()}`;
    if (from.getFullYear() !== to.getFullYear()) {
        return `${from.getDate()}.${pad(from.getMonth() + 1)}.${from.getFullYear()}–${toLabel}`;
    }
    if (from.getMonth() !== to.getMonth()) {
        return `${from.getDate()}.${pad(from.getMonth() + 1)}–${toLabel}`;
    }
    return `${from.getDate()}–${toLabel}`;
}

/** "pon.–czw." */
export function formatWeekdays(session: RetreatSession): string {
    return `${WEEKDAYS[parse(session.from).getDay()]}–${WEEKDAYS[parse(session.to).getDay()]}`;
}

/** "październik 2026" */
export function formatMonth(isoDate: string): string {
    const date = parse(isoDate);
    return `${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}
